import React, {Component} from 'react'

class TickBoxWidget extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			items: [],
			labels: props.options,
			disabled: props.disabled,
			direction: (props.direction == null)? 'column': props.direction,
			properties: {name: props.name, options: {}}
		}
		this.setItems = this.setItems.bind(this)
	}

	componentWillMount() {
		this.setItems()
	}

	componentDidUpdate(prevProps) {
		if(prevProps.default != this.props.default) {
			this.setItems()
		}
		if(prevProps.disabled != this.props.disabled) {
			this.setItems()
		}
	}

	setItems() {
		const items = []
		for(const i in this.state.labels) {
			if(this.props.disabled) {
				let background = "#ffffff"
				if(this.props.default != null) {
					if(this.props.default.includes(parseInt(i))) {
						background = "#c4c4c4"
						this.state.properties.options[i] = this.state.labels[i]
					}
				}
				items.push(<div><div style={{background: background}}></div>
					<span>{this.state.labels[i]}</span></div>)
			}
			else {
				let background = "#ffffff"
				if(this.props.default != null) {
					if(this.props.default.includes(parseInt(i))) {
						background = "rgb(143, 167, 65)"
						this.state.properties.options[i] = this.state.labels[i]
					}
				}
				items.push(<div>
					<div onClick={(e) => {
						if(e.target.style.background == "rgb(143, 167, 65)") {
							e.target.style.background = "#ffffff"
							delete this.state.properties.options[i]
						}
						else {
							e.target.style.background = "#8FA741"
							this.state.properties.options[i] = this.state.labels[i]
						}
						this.props.optionSelected(this.state.properties)
					}} style={{background: background}}></div>
					<span>{this.state.labels[i]}</span>
				</div>)
			}
		}
		this.setState({items: items})
	}

	render() {
		let view = <div className="tick-box-widget" 
			style={{'flex-direction': this.state.direction}}>
			{this.state.items}
		</div>
		return(view)
	}
}

export default TickBoxWidget
